import { Route } from '@angular/router';

export const memberRoute: Route = {
  path: 'member',
  data: {
    title: 'Member'
  },
  loadChildren: () => import('../../app/modules/member/member.module').then(m => m.MemberModule)
};